import { render, staticRenderFns } from "./unBindPage.vue?vue&type=template&id=4051758c&scoped=true&"
import script from "./unBindPage.vue?vue&type=script&lang=js&"
export * from "./unBindPage.vue?vue&type=script&lang=js&"
import style0 from "./unBindPage.vue?vue&type=style&index=0&id=4051758c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051758c",
  null
  
)

export default component.exports